import type { Hex } from "viem";
import { useDozerQuery } from "../../queries/useDozerQuery";

type RawResponse = {
  amount: string;
};

export function useBatteriesAmountQuery(userEntityId: Hex | undefined) {
  const sqlQuery = `
SELECT sum("amount") as "amount"
FROM "InventorySlot"
WHERE "owner" = '${userEntityId}' AND "objectType" = 32793;
`;

  return useDozerQuery<bigint, [[RawResponse]]>({
    sqlQuery: sqlQuery,
    select: (data) => BigInt(data[0][0]?.amount ?? 0n),
    refetchInterval: 1_000,
    enabled: !!userEntityId,
  });
}
